import { useEffect, useState } from 'react';
import { billingApi, type CommercialBundle } from '../../api/billing';

export function BundleManagerPage() {
  const [bundles, setBundles] = useState<CommercialBundle[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void billingApi.listBundles().then(setBundles).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Bundle Manager</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {bundles.map((b) => (
          <div key={b.code} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <div className="flex items-start justify-between">
              <h2 className="font-medium">{b.name}</h2>
              {b.featured && <span className="text-xs text-emerald-600">Featured</span>}
            </div>
            <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{b.description}</p>
            <p className="mt-2 text-xs text-slate-500">Modules: {b.modules?.join(', ') || '—'}</p>
            {b.credit_grant ? <p className="mt-1 text-xs">Credits: {b.credit_grant.toLocaleString()}</p> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
